module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAtUlEQVRIie3WsQrCMBRG4XOLZPMFBDefzElHV8FH6KzQxxPEud1cfpcWHCw2SXMH6ZkyhHyQBBIkBUm1pFblansj0A+8qk1SC6zxqTNJcsIAqDyxBRy6Akfg7gW+zOwG7OaAJ2+pmc0CR59hLpx8aVLh7Fv6BX4UBUfgE/AsCk5tNddCkgKwBy7Aphj4AZ2B7a/5yWAslAymQtFgLhQDBkmHXGhoefH/A+wcva4CGkewQc5f/Td/LYRIdXZxagAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/youtube.png
// module id = 875
// module chunks = 93